<template>
	<div class="overlay-test">
		<div class="overlay-bg-test"></div>
		<!-- <div class="row h-100 text-white">
			<div class="col d-flex h-100">
				<h3 class="my-auto ms-auto text-end overlay-info-test">klik op het antwoord <br />waarvan jij denkt <br />dat het goed is</h3>
			</div>
			<div class="col d-flex h-100">
				<span class="hand-icon my-auto"></span>
			</div>
		</div> -->
		<div class="overlay-layer"></div>
	</div>
</template>

<script>
export default {
	name: "QuizOverlay",
};
</script>

<style scoped>
.overlay-test {
	position: absolute;
	left: 0;
	right: 0;
	top: 0;
	bottom: 0;
}

.overlay-bg-test {
	position: absolute;
	z-index: var(--global-z-index-overlay);
	left: 0;
	right: 0;
	top: 0;
	bottom: 0;
	background-color: rgba(8, 35, 42, 0.85);
}

.overlay-items {
	position: relative;
	z-index: var(--global-z-index-overlay-items);
}

.overlay-info-test {
	position: relative;
	z-index: var(--global-z-index-overlay-info);
}

.hand-icon {
	position: relative;
	z-index: var(--global-z-index-overlay-info);
	background-image: url("~@/assets/img/icons/hand.svg");
	background-size: contain;
	background-position: center;
	background-repeat: no-repeat;
	height: 150px;
	width: 50px;
}

.overlay-layer {
	position: absolute;
	z-index: var(--global-z-index-overlay-layer);
	left: 0;
	right: 0;
	top: 0;
	bottom: 0;
}
</style>